import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useIntake } from "../context/IntakeContext";
import { LogoMark } from "./Logo";

export const CtaBand = () => {
  const intake = useIntake();
  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          data-testid="cta-band"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden bg-[#111827] rounded-[2.5rem] px-8 py-16 sm:px-16 sm:py-20 text-center"
        >
          <LogoMark
            size={340}
            className="absolute -right-20 -bottom-24 opacity-[0.08] rotate-12 pointer-events-none"
          />
          <p className="text-xs font-bold tracking-[0.35em] uppercase text-[#93C5FD] mb-6">
            Ready when you are
          </p>
          <h2 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.02] max-w-3xl mx-auto">
            They&rsquo;re counting on you doing nothing.
          </h2>
          <button
            data-testid="cta-start-case-button"
            onClick={() => intake.open("letter")}
            className="group mt-10 inline-flex items-center gap-4 bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-bold text-lg pl-8 pr-2.5 py-2.5 rounded-full transition-colors duration-300"
          >
            Start Your Case
            <span className="flex items-center justify-center w-11 h-11 rounded-full bg-white text-[#2563EB] transition-transform duration-300 group-hover:rotate-[-35deg]">
              <ArrowRight size={20} strokeWidth={2.5} />
            </span>
          </button>
          <p className="mt-6 text-sm text-[#9CA3AF]">
            Pay only when ready to send. No lawyers, no hourly bills.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
